import {
  ticketsRestResource,
  CreateProjectPlanTicketRequest,
  CreateProjectPlanTicketResponse,
  IfBulkUpdateTicketsRequest,
  IfBulkUpdateTicketsResponse,
  BulkUpdateTicketsOfIfAttributeDesignReviewRequest,
  BulkUpdateTicketsOfIfAttributeDesignReviewResponse,
  UpdateComponentAttributeTicketStatusesRequest,
  UpdateComponentAttributeTicketStatusesResponse,
} from ".";
import { useRestResourceHook } from "../use-rest-resource-hook";

export const useCreateProjectPlanTicket = () =>
  useRestResourceHook<
    CreateProjectPlanTicketRequest,
    CreateProjectPlanTicketResponse
  >((request) => ticketsRestResource.createProjectPlanTicket(request));

export const useIfBulkUpdateTickets = () =>
  useRestResourceHook<IfBulkUpdateTicketsRequest, IfBulkUpdateTicketsResponse>(
    (request) => ticketsRestResource.ifBulkUpdateTickets(request),
  );

export const useBulkUpdateTicketsOfIfAttributeDesignReview = () =>
  useRestResourceHook<
    BulkUpdateTicketsOfIfAttributeDesignReviewRequest,
    BulkUpdateTicketsOfIfAttributeDesignReviewResponse
  >((request) =>
    ticketsRestResource.bulkUpdateTicketsOfIfAttributeDesignReview(request),
  );

export const useUpdateComponentAttributeTicketStatuses = () =>
  useRestResourceHook<
    UpdateComponentAttributeTicketStatusesRequest,
    UpdateComponentAttributeTicketStatusesResponse
  >((request) =>
    ticketsRestResource.updateComponentAttributeTicketStatuses(request),
  );
